import { render, staticRenderFns } from "./ChatDashboard.vue?vue&type=template&id=b42ab122&scoped=true&"
import script from "./ChatDashboard.vue?vue&type=script&lang=js&"
export * from "./ChatDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ChatDashboard.vue?vue&type=style&index=0&id=b42ab122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ab122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
